import { Id } from "@/data/types";
import BoringAvatar from "boring-avatars";

export default function Avatar({ uid }: { uid: Id }) {
  return <BoringAvatar name={uid} size={40} variant={"beam"} />;
}
